import React from 'react';
import './Modal.css';

interface ModalProps {
  isOpen: boolean;
  title: string;
  onClose: () => void;
  children: React.ReactNode;
  variant?: 'default' | 'clausulas' | 'compact' | 'wide';
  closeOnBackdropClick?: boolean;
  showCloseButton?: boolean; // Nueva prop para controlar la visibilidad del botón X
  showTitle?: boolean; // Nueva prop para mostrar/ocultar el título
}

const Modal: React.FC<ModalProps> = ({ 
  isOpen, 
  title, 
  onClose, 
  children, 
  variant = 'default',
  closeOnBackdropClick = true,
  showCloseButton = true, // Por defecto muestra el botón
  showTitle = true
}) => {
  if (!isOpen) return null;

  // Determinar la clase CSS según la variante
  const getModalClass = () => {
    switch (variant) {
      case 'clausulas':
        return 'modal-content clausulas-modal';
      case 'compact':
        return 'modal-content compact-modal';
      case 'wide':
        return 'modal-content wide-modal';
      default:
        return 'modal-content';
    }
  };

  return (
    <>
      {/* Backdrop */}
      <div 
        className="modal-backdrop" 
        onClick={closeOnBackdropClick ? onClose : undefined}
      >
        {/* Modal Content */}
        <div className={getModalClass()} onClick={(e) => e.stopPropagation()}>
          {/* Header */}
          <div className="modal-header">
            {showTitle && <h4 className="modal-title">{title}</h4>}
            {showCloseButton && (
              <button 
                type="button"
                className="modal-close-button" 
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  onClose();
                }}
              >
                ✕
              </button>
            )}
          </div>
          
          {/* Body - El contenido se pasa como children */}
          <div className="modal-body">
            {children}
          </div>
        </div>
      </div>
    </>
  );
};

export default Modal;